/**
 * environment lookup for the analytics module
 */

export const APP_ENV = process.env.REACT_APP_ENV || "local";

export const APP_RELEASE = process.env.REACT_APP_RELEASE || "dev";

export const IS_LOCAL = APP_ENV === "local";

export const IS_DEV = process.env.NODE_ENV !== "production";

// set only in prod.yml, so Hotjar stays off on staging and locally
export const HOTJAR_SITE_ID = Number(process.env.REACT_APP_HOTJAR_SITE_ID);

export const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;
